import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM } from '~/modules/resource-management/common/enums/resourceManagementDashboardTabs';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    marginTop: theme.spacing(1)
  }
}));

const useTabsStyles = makeStyles(() => ({
  indicator: {
    display: 'none'
  }
}));

const useTabStyles = makeStyles(theme => ({
  root: {
    minHeight: 48,
    textAlign: 'left',
    padding: theme.spacing(0, 2),
    '@media (hover: any-hover)': {
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    }
  },
  selected: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
    '@media (hover: any-hover)': {
      '&:hover': {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.grey[200]
      }
    }
  }
}));

const getFormattedMessages = formatMessage => ({
  overviewTabAriaLabel: formatMessage({
    id: 'resourceManagementTabs.overview'
  }),
  insights: formatMessage({
    id: 'resourceManagementOverviewTabs.insights'
  }),
  allocation: formatMessage({
    id: 'resourceManagementOverviewTabs.allocation'
  })
});

export const ResourceManagementDashboardTabs = ({
  selectedDashboardTab,
  setSelectedDashboardTab,
  orientation
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const tabClasses = useTabStyles();
  const tabsClasses = useTabsStyles();
  const labels = getFormattedMessages(formatMessage);

  const onChange = useCallback(
    (_, tabValue) => setSelectedDashboardTab(tabValue),
    [setSelectedDashboardTab]
  );

  return (
    <Tabs
      className={classes.root}
      classes={tabsClasses}
      orientation={orientation}
      value={selectedDashboardTab}
      onChange={onChange}
      aria-label={labels.overviewTabAriaLabel}
    >
      <Tab
        value={RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.INSIGHTS}
        label={labels.insights}
        classes={tabClasses}
      />
      <Tab
        value={RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.ALLOCATION}
        label={labels.allocation}
        classes={tabClasses}
      />
    </Tabs>
  );
};

ResourceManagementDashboardTabs.propTypes = {
  selectedDashboardTab: PropTypes.oneOf([
    RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.INSIGHTS,
    RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.ALLOCATION
  ]).isRequired,
  setSelectedDashboardTab: PropTypes.func.isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
};

export default ResourceManagementDashboardTabs;
